// @flow
import type { DataLayerEvent } from '@rover/react-lib/types';
import dataLayer from '@rover/globals/dataLayer';

const pushEvent = (event: DataLayerEvent): Promise<void> =>
  new Promise(resolve => {
    // Use setTimeout to ensure the main CPU thread is freed up between invocations of GTM
    setTimeout(() =>
      dataLayer.push({
        ...event,
        eventCallback: resolve,
      })
    );
  });

const fireDataLayerEvent = (event: DataLayerEvent, timeout: number = 500): Promise<void> =>
  Promise.race([
    pushEvent(event),
    // GTM may be blocked or the script may fail to process the queue.
    // In those cases the above event promise will never resolve, so provide
    // a failsafe
    new Promise(resolve => {
      setTimeout(resolve, timeout);
    }),
  ]);

export default fireDataLayerEvent;



// WEBPACK FOOTER //
// ../utilities/fireDataLayerEvent.client.js